import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-78650710"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "top"
};
const _hoisted_3 = {
  class: "head"
};
const _hoisted_4 = {
  class: "store-name"
};
const _hoisted_5 = {
  key: 0,
  class: "display"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "displayleft displayleft3"
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "已取消", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  key: 1,
  class: "display"
};
const _hoisted_10 = {
  class: "address"
};
const _hoisted_11 = {
  class: "code"
};
const _hoisted_12 = {
  class: "code"
};
const _hoisted_13 = {
  key: 0,
  class: "code"
};
const _hoisted_14 = {
  class: "brand"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "itemname"
};
const _hoisted_17 = {
  class: "contenDetail"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icohead"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-title"
}, "任务执行情况汇总", -1));
const _hoisted_20 = {
  class: "listhead"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "display": "flex",
    "align-items": "center"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "icohead"
}), /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-weight": "600",
    "font-size": "0.3rem"
  }
}, [/*#__PURE__*/_createTextVNode("活跃情况"), /*#__PURE__*/_createElementVNode("span", {
  class: "textline"
}, "（次）")])], -1));
const _hoisted_22 = {
  class: "brand"
};
const _hoisted_23 = {
  class: "itemname"
};
const _hoisted_24 = {
  class: "listcontent"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "name",
  style: {
    "display": "flex",
    "justify-content": "space-between"
  }
};
const _hoisted_28 = {
  key: 0,
  class: "status status1"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icoday"
}, null, -1));
const _hoisted_30 = {
  key: 1,
  class: "status status2"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icoday2"
}, null, -1));
const _hoisted_32 = {
  class: "week"
};
const _hoisted_33 = {
  class: "time"
};
const _hoisted_34 = {
  key: 0,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_35 = {
  key: 1,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_36 = {
  class: "time"
};
const _hoisted_37 = {
  key: 0,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_38 = {
  key: 1,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_39 = {
  key: 2,
  style: {
    "color": "red"
  },
  class: "label"
};
const _hoisted_40 = {
  class: "bottombtn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_empty = _resolveComponent("van-empty");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.type1 === 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([$data.status1 === 'CANCELLED' ? 'over' : 'new', "new"])
  }, "新", 2)) : _createCommentVNode("", true), $data.type1 !== 'NEW' ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($data.status1 === 'CANCELLED' ? 'over' : 'notnew')
  }, null, 2)) : _createCommentVNode("", true), _createElementVNode("div", null, _toDisplayString($data.listData.terminalName), 1)]), $data.status1 === 'CANCELLED' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", {
    class: _normalizeClass(["displayleft", $data.listData.status === '已激活' ? 'displayleft1' : 'displayleft2'])
  }, null, 2), _createElementVNode("div", null, _toDisplayString($data.listData.status), 1)]))]), _createElementVNode("div", _hoisted_10, _toDisplayString($data.listData.province) + _toDisplayString($data.listData.city) + _toDisplayString($data.listData.area), 1), _createElementVNode("div", _hoisted_11, "任务：" + _toDisplayString($data.listData.positionName), 1), _createElementVNode("div", _hoisted_12, "计划发布时间：" + _toDisplayString($data.listData.publishTime), 1), $data.status1 === 'CANCELLED' ? (_openBlock(), _createElementBlock("div", _hoisted_13, "计划取消时间：" + _toDisplayString($data.listData.cancelTime), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.itemdata, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "itemdata",
      onClick: $event => $options.actcnt(index)
    }, [_createElementVNode("div", {
      class: "cnt",
      style: _normalizeStyle({
        color: item.color
      })
    }, _toDisplayString(item.cnt), 5), _createElementVNode("div", _hoisted_16, [_createTextVNode(_toDisplayString(item.name) + " ", 1), index === 2 ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      size: "14px",
      name: "info-o"
    })) : _createCommentVNode("", true)])], 8, _hoisted_15);
  }), 128))])]), _createVNode(_component_van_action_sheet, {
    show: $data.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.show = $event),
    actions: $data.actions,
    "cancel-text": "返回",
    description: "当前触点信息"
  }, null, 8, ["show", "actions"]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_van_cell, {
    "is-link": "",
    onClick: _cache[1] || (_cache[1] = $event => $options.implementationDetail('')),
    value: "详情"
  }, {
    title: _withCtx(() => [_hoisted_18, _hoisted_19]),
    _: 1
  })]), _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.itemdata1, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "itemdata"
    }, [_createElementVNode("div", {
      class: "cnt",
      style: _normalizeStyle({
        color: item.color
      })
    }, _toDisplayString(item.cnt), 5), _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1)]);
  }), 128))])]), _createElementVNode("div", _hoisted_24, [$data.pgdatalist ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pgdatalist, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "contentbox",
      key: item,
      onClick: $event => $options.implementationDetail(item)
    }, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", null, _toDisplayString(item.name), 1), item.status === 'atting' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createTextVNode(" 活跃中")])) : _createCommentVNode("", true), item.status === 'att_fail' ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_hoisted_31, _createTextVNode(" 活跃异常")])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_32, _toDisplayString(item.date), 1), _createElementVNode("div", _hoisted_33, [_createTextVNode(" 开始时间：" + _toDisplayString(item.startTime) + " ", 1), item.startStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "（ ≥ 800m 位置偏离 ）")) : _createCommentVNode("", true), item.startStatus >= 2 ? (_openBlock(), _createElementBlock("span", _hoisted_35, "（ GPS获取异常 ）")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_36, [_createTextVNode(" 结束时间：" + _toDisplayString(item.endTime ? item.endTime : '--:--') + " ", 1), item.status !== 'atting' && item.endStatus === null ? (_openBlock(), _createElementBlock("span", _hoisted_37, "（ 无 ）")) : _createCommentVNode("", true), item.endStatus === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_38, "（ ≥ 800m 位置偏离 ）")) : _createCommentVNode("", true), item.endStatus >= 2 ? (_openBlock(), _createElementBlock("span", _hoisted_39, "（ GPS获取异常 ）")) : _createCommentVNode("", true)])], 8, _hoisted_26);
  }), 128))])) : (_openBlock(), _createBlock(_component_van_empty, {
    key: 1,
    description: "暂无数据"
  }))]), _createElementVNode("div", _hoisted_40, [_createElementVNode("button", {
    class: "btn1",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goback && $options.goback(...args))
  }, "返回")])]);
}